import { gql } from 'graphql-request';

export const getSavedWords = gql`
  query GetSavedWords($userId: Int!, $active: Boolean) {
    getSavedWords(userId: $userId, active: $active) {
      id
      userId
      word
      active
      simplified
      traditional
      translation
      pinyin
      skill
    }
  }
`;

export const getQuizResults = gql`
  query GetQuizResults(
    $userId: Int
    $quizType: String
    $contentType: String
    $ordering: String
  ) {
    getQuizResults(
      userId: $userId
      quizType: $quizType
      contentType: $contentType
      ordering: $ordering
    ) {
      id
      userId
      quizType
      contentType
      contentId
      correct
      mistakes
      score
      trials
      strokes
      simplified
      traditional
      skill
      sentence
    }
  }
`;

export const getQuizResult = gql`
  query GetQuizResult($id: Int!) {
    getQuizResult(id: $id) {
      id
      userId
      quizType
      contentType
      contentId
      correct
      mistakes
      score
      trials
      strokes
    }
  }
`;

export const createQuizResult = gql`
  mutation CreateQuizResult(
    $userId: Int!
    $quizType: String!
    $contentType: String!
    $contentId: Int!
    $correct: Int!
    $mistakes: Int!
    $score: Float!
    $trials: Int = 1
    $strokes: Int
  ) {
    createQuizResult(
      userId: $userId
      quizType: $quizType
      contentType: $contentType
      contentId: $contentId
      correct: $correct
      mistakes: $mistakes
      score: $score
      trials: $trials
      strokes: $strokes
    ) {
      id
      userId
      quizType
      contentType
      contentId
      correct
      mistakes
      score
      trials
      strokes
    }
  }
`;

export const updateQuizResult = gql`
  mutation UpdateQuizResult(
    $id: Int!
    $correct: Int
    $mistakes: Int
    $score: Float
    $trials: Int
    $strokes: Int
  ) {
    updateQuizResult(
      id: $id
      correct: $correct
      mistakes: $mistakes
      score: $score
      trials: $trials
      strokes: $strokes
    ) {
      id
      userId
      quizType
      contentType
      contentId
      correct
      mistakes
      score
      trials
      strokes
    }
  }
`;

export const deleteQuizResult = gql`
  mutation DeleteQuizResult($id: Int!) {
    deleteQuizResult(id: $id)
  }
`;
